import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LazyElementsModule } from '@angular-extensions/elements';
import { ClaimsSupportComponent } from './components/claims-support/claims-support.component';


@NgModule({
  declarations: [
    ClaimsSupportComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    LazyElementsModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class ClaimsSupportModule { }
